module.exports = __webpack_public_path__ + "img/reference.d70a7660.jpg";